module.exports = __webpack_public_path__ + "static/media/hopinIcon.6e78d0a3.png";